module.exports = __webpack_public_path__ + "img/tour-8.a846a103.png";